export default {
  incidents: {
    filterTitle: 'Nach Status filtern',
    label: 'Vorfälle',
    actions: {
      report: 'Bericht',
    },
    status: {
      reported: 'gemeldet',
      all: 'alle',
    },
    reports: {
      label: 'Gemeldete Vorfälle',
      new: 'Vorfall melden',
      view: 'Vorfall ansehen',
      dateOfIncident: 'Datum des Vorfalles',
      department: 'Abteilung',
      category: 'Kategorie',
      categoryItem: 'Kategorie Artikel',
      description: 'Beschreibung des Vorfalles',
      patient: 'Patient',
      code: 'Code',
      reportedBy: 'Gemeldet von',
      reportedOn: 'Gemeldet am',
      status: 'Status',
      error: {
        dateRequired: 'Datum is erforderlich.',
        dateMustBeInThePast: 'Datum muss in der vergangenheit sein.',
        departmentRequired: 'Abteilung ist erforderlich.',
        categoryRequired: 'Kategorie ist erforderlich',
        categoryItemRequired: 'Kategorie Artikel ist erforderlich',
        descriptionRequired: 'Beschreibung ist erforderlich',
      },
    },
  },
}
